module.exports = __webpack_public_path__ + "static/media/insta.66bc630f.svg";